import { h, Component } from 'preact';
import Measure from 'react-measure';
import { getInstrumentLink, getInstrumentTradeLink, formatNumber } from '@/utils';
import { ThemeHoC, I18nHoc } from '@/components/hoc';
import styles from './style.css';

export class InstrumentItem extends Component {
    constructor (props) {
        super(props);
        this.state = {
            dimensions: {
                width: -1,
                height: -1
            }
        };
    }

    shouldComponentUpdate (nextProps, nextState) {
        const { value } = this.props.instrument;
        const nextValue = nextProps.instrument.value;
        const { theme } = this.props;

        this.tickClass = value === nextValue
            ? ''
            : value > nextValue
                ? theme['tickNeg']
                : theme['tickPos'];

        return (
            value !== nextValue ||
            this.state.dimensions.width !== nextState.dimensions.width
        );
    }

    componentWillUpdate () {
        const { theme } = this.props;
        if (this.tickClass.length && this.tickerContainer) {
            window.requestAnimationFrame((t) => {
                let tickClass = this.tickClass;
                this.tickerContainer.classList.remove(theme['tickPos']);
                this.tickerContainer.classList.remove(theme['tickNeg']);
                window.requestAnimationFrame((t) => {
                    if (this.tickerContainer && tickClass) this.tickerContainer.classList.add(tickClass);
                });
            });
        }
    }

    render ({ instrument, className, theme, I18n }) {
        const { alias, value, percentChange } = instrument;
        const { width } = this.state.dimensions;

        let rowrClassName = [styles.row, theme.tableRow];
        let isMobile = !window.matchMedia('(min-width: 480px)').matches;

        if ((width >= 480 || width === -1 || width === 0) && !isMobile) {
            rowrClassName.push(styles.tablet);
        }

        if (className) {
            rowrClassName.push(className);
        }

        return (
            <Measure
                bounds
                onResize={(contentRect) => {
                    this.setState({ dimensions: contentRect.bounds });
                }}
            >
                {({ measureRef }) =>
                    <div className={ rowrClassName.join(' ') } ref={ measureRef }>
                        <div className={styles.name} data-section="name">
                            <a
                                href={getInstrumentLink(instrument)}
                                title={ alias }
                                style={{ color: theme.textColor }}
                            >
                                {alias}
                            </a>
                        </div>
                        <div className={`${styles.values}`} data-section="values">
                            <div
                                className={styles.value}
                                data-section="value"
                            >
                                <span
                                    ref={elm => {
                                        this.tickerContainer = elm;
                                    }}
                                >
                                    {formatNumber(value)}
                                </span>
                            </div>
                            <div
                                data-section="percent"
                                className={
                                    percentChange > 0
                                        ? `${styles.precent} ${theme.colorPositive}`
                                        : `${styles.precent} ${theme.colorNegative}`
                                }
                            >
                                <span>{formatNumber(percentChange)}%</span>
                            </div>
                        </div>
                        <div className={styles.buttons} data-section="buttons">
                            <a
                                data-button="buy"
                                href={getInstrumentTradeLink(instrument)}
                                target="_blank"
                                rel="noopener"
                                className={`${theme.btn} ${theme.btnUp} ${theme.btnSmall}`}>{I18n.t("Buy")}</a>
                            <a
                                data-button="sell"
                                href={getInstrumentTradeLink(instrument)}
                                target="_blank"
                                rel="noopener"
                                className={`${theme.btn} ${theme.btnDown} ${theme.btnSmall}`}>{I18n.t("Sell")}</a>
                        </div>
                    </div>
                }
            </Measure>
        );
    }
}

export default ThemeHoC(
    I18nHoc(
        InstrumentItem
    )
);



// WEBPACK FOOTER //
// ./src/components/list/item/index.js